import NiceModal, { useModal } from '@ebay/nice-modal-react'

import ModalContainer from 'components/ModalContainer'
import { useAddVehicle } from 'util/mutations'
import { useState } from 'react'
import { CheckIcon, TruckIcon, UserIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Button, Card, Input, Form } from 'components/gsys-ui'
import { vehicleValidation } from 'util/validations'
import VehicleForm from 'components/vehicles/VehicleForm'

const AddVehicleModal = NiceModal.create(() => {
  const modal = useModal()
  const mutation = useAddVehicle()

  const handleSubmit = (res) => {
    modal.remove()
  }

  return (
    <ModalContainer>
      <Card className="!w-[500px]">
        <Card.Title Icon={TruckIcon}>Add a vehicle</Card.Title>
        <Card.Body>
          <Form
            validation={vehicleValidation}
            mutation={mutation}
            FormComp={VehicleForm}
            onSubmit={handleSubmit}
          />
        </Card.Body>
      </Card>
    </ModalContainer>
  )
})

export default AddVehicleModal